import React from 'react';
import img from '../../../assets/icons/payment-logos/stripe.svg';
const Stripe = () => {
  return (
    <img src={img} alt="/" />
  );
}

export default Stripe;
